import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import AllForms from '../../components/AutoReports/AllForms';
import { URL_AUTO_REPORTS } from '../../router/constants';
import useAnalytics from '../../hooks/useAnalytics';

// No permission gate: matches the original (wouter) router, where /auto-reports/edit rendered for
// any logged-in user (no `access` prop). Visibility is controlled by the backend-driven main menu.
export const Route = createFileRoute('/_authenticated/auto-reports/edit/$id')({
  beforeLoad: ({ context }) => {
    return {
      ...context,
      documentTitle: {
        main: 'systemSettings.editBtn',
        suffix: 'menu.autoReports',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditAutoReportRoute,
});

function EditAutoReportRoute() {
  const navigate = useNavigate();
  const { trackEvent } = useAnalytics();

  const handleClose = useCallback(() => {
    navigate({ to: URL_AUTO_REPORTS });
    trackEvent(['auto reports', 'click', 'Autoreports close']);
  }, [navigate, trackEvent]);

  const { id } = Route.useParams();

  return <AllForms closeCallback={handleClose} editingItemId={Number(id)} />;
}
